// This file contains the configurations for web client.

// const APIHostURL = "http://localhost:5000";
// const APIHostURL = "http://35.154.69.58:3010";
const APIHostURL = "";

const SingleDeviceDataRefreshTime = 300000;
const LPGSingleDeviceDataRefreshTime = 5000;
const AllDeviceDataRefreshTime = 300000;
const AlertLogDataRefreshTime = 300000;
const MappedToiletDataRefreshTime = 300000;
const DeviceActiveStatusRefreshTime = 300000; 
const DeviceActiveStatusTimeOut = 5000;  // 5 Seconds for Timout while checking device active status
const MappedToiletTrackingIntervalDataRefreshTime = 60000;

const DEVC_SW_LOCATION_ON_SRVR = 'hhmweb-server/devicesoftware';

function getAPIHostURL() {
    return APIHostURL;
}

function getSingleDeviceDataRefreshTime() {
    return SingleDeviceDataRefreshTime;
}

// This function is implemented for testing purpose of LPG model or for any model consisting 'LPG' parameter
function getLPGSingleDeviceDataRefreshTime() {
    return LPGSingleDeviceDataRefreshTime;
}

function getAllDeviceDataRefreshTime() {
    return AllDeviceDataRefreshTime;
}

function getAlertLogDataRefreshTime(){
    return AlertLogDataRefreshTime;
}

function getMappedToiletDataRefreshTime(){
    return MappedToiletDataRefreshTime;
}

function getMappedToiletTrackingDataRefreshTime(){
    return MappedToiletTrackingIntervalDataRefreshTime;
}

function getDevcSwLocnOnSrvr(){
    return DEVC_SW_LOCATION_ON_SRVR;
}

function getDeviceActiveStatusRefreshTime() {
    return DeviceActiveStatusRefreshTime;
}

function getDeviceActiveStatusTimeOut() {
    return DeviceActiveStatusTimeOut;
}



exports.getAPIHostURL = getAPIHostURL;
exports.getDevcSwLocnOnSrvr = getDevcSwLocnOnSrvr;
exports.getSingleDeviceDataRefreshTime = getSingleDeviceDataRefreshTime;
exports.getLPGSingleDeviceDataRefreshTime = getLPGSingleDeviceDataRefreshTime;
exports.getAllDeviceDataRefreshTime = getAllDeviceDataRefreshTime;
exports.getAlertLogDataRefreshTime = getAlertLogDataRefreshTime;
exports.getMappedToiletDataRefreshTime = getMappedToiletDataRefreshTime;
exports.getDeviceActiveStatusRefreshTime = getDeviceActiveStatusRefreshTime;
exports.getDeviceActiveStatusTimeOut = getDeviceActiveStatusTimeOut;
exports.getMappedToiletTrackingDataRefreshTime = getMappedToiletTrackingDataRefreshTime;
